import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { s } from "@utils/metrics_1";
import color from "@constants/color";
import LottieView from "lottie-react-native";
import NoDelivery from "@assets/svg/ShopPerformance/NoDelivery";
import LateDelivery from "@assets/svg/ShopPerformance/LateDelivery";
import ReturnPickup from "@assets/svg/ShopPerformance/ReturnPickup";
import BadBehaviour from "@assets/svg/ShopPerformance/BadBehaviour";
import FakeRto from "@assets/svg/ShopPerformance/FakeRto";

const ComplaintCard = ({ customer_complaints }) => {
  const animationType = {
    good: require("../../assets/anim/very-happy.json"),
    bad: require("../../assets/anim/sad.json"),
  };
  return (
    <View style={styles.container}>
      {customer_complaints?.map((item) => (
        <View style={styles.complaintsContainer}>
          <View style={styles.complaintsHeader}>
            <LottieView
              source={animationType[item?.icon]}
              autoPlay
              loop
              style={{
                height:
                  animationType[item?.icon] === animationType.good
                    ? 40
                    : animationType[item?.icon] === animationType.bad
                      ? 60
                      : 50,
                paddingLeft:
                  animationType[item?.icon] === animationType.good ? 8 : 0,
                marginRight:
                  animationType[item?.icon] === animationType.good ? 8 : -8,
              }}
            />
            <View style={styles.textContainer}>
              <Text style={styles.subText}>{item.month_text}</Text>
              <Text style={styles.itemText}>{item.heading}</Text>
            </View>

            <Text style={styles.numberText}>{item.number}</Text>
          </View>
          <View
            style={{
              marginHorizontal: s.xs,
              marginBottom: s.xxl,
              marginTop: s.m,
            }}
          >
            {item.complaints?.map((each, index) => (
              <View>
                {index !== 0 && <Separator />}
                <ComplaintItem item={each} />
              </View>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};

const Separator = () => <View style={styles.separator} />;

const ComplaintItem = ({ item }) => {
  const complaintType = {
    NO_DELIVERY: <NoDelivery />,
    LATE_DELIVERY: <LateDelivery />,
    RETURN_PICKUP: <ReturnPickup />,
    BAD_BEHAVIOUR: <BadBehaviour />,
    FAKE_RTO: <FakeRto />,
  };

  return (
    <View style={styles.complaintItemContainer}>
      {complaintType[item.type]}
      <View style={{ flexDirection: "column", width: "80%", marginLeft: s.xs }}>
        <Text style={styles.complaintsText}>{item.text}</Text>
        <Text style={styles.subText}>{item.subtext}</Text>
      </View>
      <Text style={[styles.numberText, { fontSize: 20 }]}>{item.qty}</Text>
    </View>
  );
};

export default ComplaintCard;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    flex: 1,
  },
  separator: {
    opacity: 0.3,
    marginHorizontal: 36,
    fontSize: 8,
    borderBottomColor: "black",
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  complaintItemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 10,
    marginHorizontal: s.xxl,
    paddingRight: s.xs,
    paddingVertical: s.s,
  },
  complaintsText: {
    fontFamily: "Noto Sans Devanagari",
    fontSize: 14,
    fontWeight: "600",
    color: color.black,
  },
  textContainer: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "flex-start",
    paddingLeft: s.m,
    paddingVertical: s.xl,
  },
  itemText: {
    fontFamily: "Noto Sans Devanagari",
    fontSize: 16,
    fontWeight: "700",
    color: color.black,
  },
  subText: {
    marginTop: s.xs,
    fontFamily: "Noto Sans Devanagari",
    fontSize: 12,
    fontWeight: "500",
    color: color.lightBlack,
  },
  numberText: {
    fontFamily: "Noto Sans Devanagari",
    fontSize: 24,
    fontWeight: "700",
    color: color.primary,
  },
  complaintsContainer: {
    marginVertical: s.m,
    backgroundColor: "#F6F8FA",
    borderRadius: 16,
    marginHorizontal: s.m,
  },
  complaintsHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: color.white,
    margin: s.m,
    borderRadius: 10,
    paddingRight: s.xl,
  },
});
